export default "__VITE_ASSET__DfCM8VM4__"